<script lang="ts">
	// @ts-nocheck
	import * as Carousel from '$lib/components/ui/carousel/index.js';
	import type { CarouselAPI } from '$lib/components/ui/carousel/context.js';
	import { enhancedImages } from '$lib/utils/images';

	let { tour } = $props();
	let videos = [
		{
			productCode: 'P18ZC5', // Replace with your actual product code
			src: 'https://www.youtube.com/embed/hAkxkStVOQQ' // Replace with your actual YouTube video ID or embed URL
		},
		{
			productCode: 'PJHLE0', // Replace with your actual product code
			src: 'https://www.youtube.com/embed/sOVKn60RX9s' // Replace with your actual YouTube video ID or embed URL
		},
		{
			productCode: 'PQKW4C', // Replace with your actual product code
			src: 'https://www.youtube.com/embed/MqVeiwLNYYY' // Replace with your actual YouTube video ID or embed URL
		},
		{
			productCode: 'PNVP8M', // Replace with your actual product code
			src: 'https://www.youtube.com/embed/FRktDNIX8Mo' // Replace with your actual YouTube video ID or embed URL
		},
		{
			productCode: 'PTC0KJ', // Replace with your actual product code
			src: 'https://www.youtube.com/embed/5E2OmcTbHcs' // Replace with your actual YouTube video ID or embed URL
		}
	];

	let api = $state<CarouselAPI>();
	const count = $derived(api ? api.scrollSnapList().length : 0);
	let current = $state(0);

	$effect(() => {
		if (api) {
			current = api.selectedScrollSnap() + 1;
			api.on('select', () => {
				current = api!.selectedScrollSnap() + 1;
			});
		}
	});
</script>

<section class="mx-auto flex w-full max-w-7xl flex-col px-4 pb-0 pt-20 sm:pb-12">
	<h2
		class="mt-10 scroll-m-20 pb-2 font-heading text-2xl font-semibold tracking-tight transition-colors first:mt-0 lg:text-3xl"
	>
		Gallery
	</h2>
	{#if videos.some((v) => v.productCode === tour.productCode)}
		<div
			class="mx-auto flex w-full max-w-7xl flex-col gap-4 overflow-hidden py-12 lg:grid lg:grid-cols-4"
		>
			<div class=" col-span-3 aspect-video">
				<Carousel.Root
					setApi={(emblaApi) => (api = emblaApi)}
					class="w-full rounded-3xl"
					opts={{ align: 'start', loop: true }}
				>
					<Carousel.Content class=" rounded-3xl lg:h-[480px]">
						<Carousel.Item class="aspect-video w-full lg:h-[480px]">
							<iframe
								src={videos.find((v) => v.productCode === tour.productCode)?.src}
								title="YouTube video player"
								class="h-full w-full rounded-3xl"
								frameborder="0"
								allowfullscreen
							></iframe>
						</Carousel.Item>
						{#each tour.images as image, index}
							<Carousel.Item class="aspect-video w-full lg:h-[480px]">
								{#if index === 0}
									<enhanced:img
										src={Object.entries(enhancedImages).find(
											([key, value]) => key === tour.images[0].itemUrl
										)[1].default}
										alt={tour.name}
										class="h-full w-full rounded-3xl object-cover"
										sizes="(min-width: 1024px) 1024px, 100vw"
										loading="lazy"
									/>
								{:else}
									<img
										src={image.itemUrl}
										alt={tour.name}
										class="h-full w-full rounded-3xl object-cover"
									/>
								{/if}
							</Carousel.Item>
						{/each}
					</Carousel.Content>
				</Carousel.Root>
			</div>

			<div class="relative col-span-1 flex w-full gap-4 overflow-auto lg:h-[480px] lg:flex-col">
				{#each tour.images as image, index}
					<button
						aria-label="gallery-select"
						onclick={() => api.scrollTo(index + 1)}
						class="relative w-full p-20 transition"
					>
						{#if index === 0}
							<enhanced:img
								src={Object.entries(enhancedImages).find(
									([key, value]) => key === tour.images[0].itemUrl
								)[1].default}
								class="absolute inset-0 h-full w-full rounded-xl object-cover lg:rounded-3xl"
								alt={tour.name}
								sizes="(min-width: 1024px) 25vw, 100px"
								loading="lazy"
							/>
						{:else}
							<img
								src={image.itemUrl}
								class="absolute inset-0 h-full w-full rounded-xl object-cover lg:rounded-3xl"
								alt={tour.name}
							/>
						{/if}
					</button>
				{/each}
				<button
					aria-label="gallery-select"
					onclick={() => api.scrollTo(0)}
					class="relative w-full p-20 transition"
					><iframe
						src={videos.find((v) => v.productCode === tour.productCode)?.src}
						title="YouTube video player"
						class="pointer-events-none absolute inset-0 h-full w-full rounded-xl object-cover lg:rounded-3xl"
						frameborder="0"
						allowfullscreen
					></iframe></button
				>
			</div>
		</div>
	{:else}
		<div
			class="mx-auto flex w-full max-w-7xl flex-col gap-4 overflow-hidden py-12 lg:grid lg:grid-cols-4"
		>
			<div class=" col-span-3 aspect-video">
				<Carousel.Root
					setApi={(emblaApi) => (api = emblaApi)}
					class="w-full rounded-3xl"
					opts={{ align: 'start', loop: true }}
				>
					<Carousel.Content class=" rounded-3xl lg:h-[480px]">
						{#each tour.images as image, index}
							<Carousel.Item class="aspect-video w-full lg:h-[480px]">
								{#if index === 0}
									<enhanced:img
										src={Object.entries(enhancedImages).find(
											([key, value]) => key === tour.images[0].itemUrl
										)[1].default}
										alt={tour.name}
										class="h-full w-full rounded-3xl object-cover"
										sizes="(min-width: 1024px) 1024px, 100vw"
										loading="lazy"
									/>
								{:else}
									<img
										src={image.itemUrl}
										alt={tour.name}
										class="h-full w-full rounded-3xl object-cover"
									/>
								{/if}
							</Carousel.Item>
						{/each}
					</Carousel.Content>
				</Carousel.Root>
			</div>
			<div class="relative col-span-1 flex w-full gap-4 overflow-auto lg:h-[480px] lg:flex-col">
				{#each tour.images as image, index}
					<button
						aria-label="gallery-select"
						onclick={() => api.scrollTo(index)}
						class="relative w-full p-20 transition"
						>{#if index === 0}
							<enhanced:img
								src={Object.entries(enhancedImages).find(
									([key, value]) => key === tour.images[0].itemUrl
								)[1].default}
								class="absolute inset-0 h-full w-full rounded-xl object-cover lg:rounded-3xl"
								alt={tour.name}
								sizes="(min-width: 1024px) 25vw, 100px"
								loading="lazy"
							/>
						{:else}
							<img
								src={image.itemUrl}
								class="absolute inset-0 h-full w-full rounded-xl object-cover lg:rounded-3xl"
								alt={tour.name}
							/>
						{/if}
					</button>
				{/each}
			</div>
		</div>
	{/if}
</section>
